const React = require('react');

exports.Awards = class Awards extends React.Component{
   constructor(props) {
      super(props);
   }

   render() {

      return (
         <div className='container-fluid awards-container'>
            <h2>Awards</h2>
            Coming Soon!
         </div>
      );
   }
};
